import { createSelector } from 'reselect';
import getKey from '@utils/get-key';

export const selectRoot = state => getKey(state, 'search') || {};
export const selectOptimizely = state => getKey(state, 'optimizely') || {};

export const selectSeoData = createSelector(selectRoot, rootState =>
  getKey(rootState, 'seoData'),
);

export const makeSelectQuery = () =>
  createSelector(selectRoot, rootState => getKey(rootState, 'query'));

export const makeSelectLoading = () =>
  createSelector(selectRoot, rootState => getKey(rootState, 'loading'));

export const makeSelectData = () =>
  createSelector(selectRoot, rootState => getKey(rootState, 'data'));

export const makeSelectError = () =>
  createSelector(selectRoot, rootState => getKey(rootState, 'error'));

export const makeSelectLocations = () =>
  createSelector(selectRoot, rootState => getKey(rootState, 'locations'));

export const makeSelectRefineCategories = () =>
  createSelector(selectRoot, rootState =>
    getKey(rootState, 'refineCategories'),
  );

export const makeSelectCategory = () =>
  createSelector(selectRoot, rootState => getKey(rootState, 'category'));

export const selectLocationToPostcodeClient = createSelector(
  selectRoot,
  rootState => getKey(rootState, 'locationToPostcode'),
);

export const makeSelectLocationToPostcode = isServer =>
  createSelector(selectRoot, rootState =>
    isServer ? {} : getKey(rootState, 'locationToPostcode'),
  );

export const makeSelectLocation = () =>
  createSelector(selectRoot, rootState => getKey(rootState, 'location'));

export const selectPostcode = createSelector(selectRoot, rootState =>
  getKey(rootState, 'postcode'),
);

export const makeSelectPostcode = () => selectPostcode;

export const makeSelectKey = () =>
  createSelector(selectRoot, rootState => getKey(rootState, 'key'));

export const selectInitialDecisions = createSelector(
  selectOptimizely,
  optimizelyState => getKey(optimizelyState, 'initialDecisions') || {},
);

export const makeSelectOptimizelyDecisions = () => selectInitialDecisions;

export const makeSelectOptimizelyStoredDecision = key =>
  createSelector(selectInitialDecisions, decisions => getKey(decisions, key));
